"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultDeparture = void 0;
const countries_1 = require("../config/countries");
const getValuesFromBackend_1 = require("./getValuesFromBackend");
const getDefaultDeparture = () => {
    const { country } = (0, getValuesFromBackend_1.getLocalizationValues)();
    const value = countries_1.defaultDepartures.get(country);
    if (value) {
        return value;
    }
    return countries_1.moscowDeparture;
};
exports.getDefaultDeparture = getDefaultDeparture;
